import { render, staticRenderFns } from "./SourceSearch.vue?vue&type=template&id=667a81f2"
import script from "./SourceSearch.vue?vue&type=script&lang=js"
export * from "./SourceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports